import { render, staticRenderFns } from "./CheckParcel.vue?vue&type=template&id=13dc08be&"
import script from "./CheckParcel.vue?vue&type=script&lang=js&"
export * from "./CheckParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports